<template>
    <p class="control">
<!--        <quill-editor v-model="message" :  :class="{'is-danger': hasError}" :options="editorOptions" @change="change" />-->
      <quill-editor v-model:content="message" :content-type="'html'" :class="{'is-danger': hasError}" :options="editorOptions" @change="change" />
        <form-error :error="error" />
    </p>
</template>

<script>
    import {QuillEditor} from "@vueup/vue-quill";
    export default {
      components: {QuillEditor},
      props: ['value', 'error', 'users', 'hashes'],

        computed: {
            message: {
                get() {
                    return this.value
                },
                set(newValue) {
                    this.$emit('input', newValue)
                }
            },
            quillUsers() {
                return _.map(this.users, p => { return { id: p.id, value: `${p.first_name} ${p.last_name}`, denotationChar: '@' } })
            },
            hasError() {
                return !!this.error
            }
        },
        data() {
            return {
                editorOptions: {
                    modules: {
                        mention: this.users ? {
                            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                            mentionDenotationChars: ["@", "#"],
                            showDenotationChar: false,
                            defaultMenuOrientation: 'bottom',
                            minChars: 1,
                            source: this.sources 
                        } : undefined,
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            [{ 'script': 'sub'}, { 'script': 'super' }],

                            //[{ 'size': ['small', false, 'large', 'huge'] }],
                            //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                            [{ 'color': [] }, { 'background': [] }],
                            //[{ 'font': [] }],
                            //[{ 'align': [] }],

                            ['image'],
                            ['clean']
                        ]
                    }
                },
                mentionedUsers: []
            }
        },
        methods: {
            sources(searchTerm, renderList, mentionChar) {
                let values
                if (mentionChar === "@") {
                    values = this.quillUsers
                } else {
                    values = this.hashes
                }
                if (searchTerm.length === 0) {
                    renderList(values, searchTerm)
                } else {
                    const matches = [];
                    for (let i = 0; i < values.length; i++)
                        if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) matches.push(values[i])
                    renderList(matches, searchTerm)
                }
            },
            change(editor, html, text) {
                var marvelDelta = editor.editor.editor.delta
                var mentionDelta = _.filter(marvelDelta.ops, 'insert.mention');
                var mentions = _.map(mentionDelta, function(value){
                    return _.toInteger(_.get(value, 'insert.mention.id'));
                });
                if(JSON.stringify(this.mentionedUsers) != JSON.stringify(mentions)) {
                    this.mentionedUsers = mentions
                    this.$emit('mentionchanged', this.mentionedUsers)
                }
            }
    }
}
</script>